import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  resetForm,
  getCatalogById,
  modifyCatalog,
  addCatalog,
  updateCatalog,
  addElement,
  removeElement,
} from 'catalogs/actions';

import { getEditing } from 'catalogs/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';

import { valueFromEvent, createRoute } from 'lib/util';

class CatalogsFormHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false, isSaving: false };

  componentWillMount = () => {
    const { did } = this.props.match.params;
    this.props.reset();
    did && this.props.getById(did, this.props.company.id, this.props.subcompany.id);
  };

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true, isValid, isSaving: true }, () => {
      if (isValid) {
        const promise = this.props.catalog.id
          ? this.props.update(
              this.props.catalog.id,
              this.props.company.id,
              this.props.subcompany.id,
              this.props.catalog
            )
          : this.props.add(this.props.company.id, this.props.subcompany.id, this.props.catalog);

        promise
          .then(({ value }) => {
            this.props.success(value.message);
            this.props.history.push(
              createRoute(this.props.company.id, this.props.subcompany.id, 'catalogs')
            );
          })
          .catch((err) => {
            this.props.error(err.message);
            this.finishSaving();
          });
      } else {
        this.props.error('error.verify');
        this.finishSaving();
      }
    });
  };

  finishSaving = () => this.setState({ isSaving: false });

  handleValueChange = (e) => this.props.modify(valueFromEvent(e));

  handleValidation = (isValid) => this.setState({ isValid });

  handleAddElement = () => this.props.addElement();

  handleRemoveElement = (index) => this.props.removeElement(index);

  render = () =>
    this.props.render({
      isSaving: this.state.isSaving,
      isSubmitted: this.state.isSubmitted,
      handleAddElement: this.handleAddElement,
      handleRemoveElement: this.handleRemoveElement,
      handleSubmit: this.handleSubmit,
      handleValueChange: this.handleValueChange,
      handleValidation: this.handleValidation,
    });
}

const mapStateToProps = (state) => ({
  catalog: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

const mapDispatchToProps = {
  add: addCatalog,
  error: addGrowlError,
  getById: getCatalogById,
  modify: modifyCatalog,
  reset: resetForm,
  success: addGrowlSuccess,
  update: updateCatalog,
  addElement,
  removeElement,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CatalogsFormHandlers));



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/containers/CatalogFormHandlers.js